<div class="form-horizontal" ngForm="producerSettingsForm">

	<div class="form-group row">
		<label class="control-label col-sm-3">{{ 'Event_Producer_AddEditBackgroundImages' | translate }}</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div *ngIf="canAddBg()" fileUpload (onAdd)="addBgImage($event.file)" class="btn-file-wrapper">
						<div vbBtnPrimary>
							{{ 'AddNew' | translate }}
							<input type="file" [accept]="imgExtensions" name="producerBgImageFile" multiple="multiple" [attr.aria-label]="'AddNew' | translate">
						</div>
						<span class="margin-left-15">{{'RecommendedImageSize1080p' | translate }}</span>

						<div vbUiErrorMessage *ngIf="invalidFileType">
							{{ 'ImageSelector_FileExtensionError' | translate }}: {{imgExtensions}}
						</div>
					</div>

					<div [ngClass]="styles.tileGrid" *ngIf="webcast.producerBgImages.length">
						<div *ngFor="let img of webcast.producerBgImages" [style.background-image]="getThumbnail(img)">
							<vb-loading-spinner *ngIf="isLoading(img)" [block]="true">
							</vb-loading-spinner>

							<button type="button" (click)="removeBgImage(img)" [attr.aria-label]="'Remove' | translate">
								<span class="glyphicons remove_2"></span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
